import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "./AccountPage.css";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Images from "../../constants/Images";
import { format, parse } from "date-fns";
import { fr } from "date-fns/locale"; 
import { apiRequest } from "../../services";
const AccountPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const accountData = location.state?.account;
  console.log("useLocation ===: ", location)
  const userData = useSelector((state) => state.users);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [insurancePackages, setInsurancePackages] = useState([]);
  const [notification, setNotification] = useState(null);
  const [isAffiliated, setIsAffiliated] = useState(
    accountData.associatedWithAInsurance || null
  );
  const [affiliatedPackageId, setAffiliatedPackageId] = useState(
    accountData.insuranceSubscriptionId || null
  );
  const packageImageMap = {
    bronze: Images.Bronze,
    platinium: Images.Platinium,
    silver: Images.Silver,
    gold: Images.Gold,
  };

  const defaultPackageImage = Images.default || "/path/to/default/image.png";

  const handleNavigate = (insuranceId) => {
    navigate(`/claims`, {
      state: { insuranceId: insuranceId },
    });
  };

  const handleNavigateInsured = () => {
    // navigate(`/assuré`, {
    //   state: { accountInsured: accountData },
    // });
        navigate(`/assure`, {
      state: { accountInsured: accountData },
    });
  };

  const handleNavigateMonCompte = () => {
    navigate(`/beneficiary`);
  };

  const handleNavigateAddInsured = () => {
    navigate(`/addBeneficiary`, {
      state: {
        accountId: accountData.id,
        accountName: accountData.savingPlanDescription,
        subscriptionPackageId: accountData.insurancePackageSubscriptionId,

      },
    });
  };

  const handleNavigateHistory = () => {
    navigate(`/mes-historiques`, {
      state: { account: accountData },
    });
  };

  const handleSelectPackage = (pkg) => {
    console.log(`Opening modal for package: ${pkg.name}`);
    setSelectedPackage(pkg);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPackage(null);
  };

  // const handleConfirmPackage = async () => {
  //   console.log(`Confirmed package: ${selectedPackage?.name}`);
  //   try {
  //     const formData = {
  //       accountId: accountData?.id,
  //       insurancePackageId: selectedPackage?.id,
  //     };
  //     const request = {
  //       serviceReference: "ADD_INSURANCE_PACKAGE_TO_ACCOUNT",
  //       requestBody: JSON.stringify(formData),
  //     };

  //     const response = await apiRequest(
  //       "GATEWAY",
  //       "",
  //       "POST",
  //       request,
  //       userData.users.token
  //     );

  //     console.log("response is ", response);
  //     if (response?.body?.meta?.statusCode === 200) {
  //       setNotification({
  //         type: "success",
  //         message: t(
  //           `Votre souscription au package ${selectedPackage.name} a été exécutée avec succès ! Pensez à ajouter un assuré pour bénéficier de cette assurance.`
  //         ),
  //       });
  //       getAllPackageInsurance();
  //       handleNavigateAddInsured(
  //         accountData.accountId,
  //         accountData.savingPlanDescription
  //       );
  //     }
  //     if (response?.body?.meta.statusCode === 409) {
  //       setNotification({
  //         type: "error",
  //         //message: t(response?.body?.errors),
  //         message: t(
  //           `Désolé, vous êtes déjà souscrit au package ${selectedPackage.name}. Vous ne pouvez pas souscrire à nouveau à ce package.`
  //         ),
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error subscribing to package:", error);
  //     setNotification({
  //       type: "error",
  //       message: t("Une erreur s'est produite. Veuillez réessayer plus tard."),
  //     });
  //   }
  //   setShowModal(false);
  //   setSelectedPackage(null);
  //   setTimeout(() => setNotification(null), 20000);
  // };

  const progressPercentage = accountData?.savingPlanDescription.includes(
    "FREE_SAVING"
  )
    ? 100
    : Math.min(
        Math.round((accountData.balance / accountData.targetAmount) * 100),
        100
      );

  const getAllPackageInsurance = async () => {
    try {
      console.log("account data ", accountData);
      const requestData = {
        serviceReference: "GET_PACKAGE_BY_ID",
        requestBody: accountData.insurancePackageSubscriptionId,
      };

      const response = await apiRequest(
        "GATEWAY",
        "",
        "POST",
        requestData,
        userData.token,
        dispatch,
        navigate
      );
      console.log("response is ", response);

      if (response && response.status === 200 && response.body.data) {
        const pkg = response.body.data;
        const packageWithImage = {
          ...pkg,
          image: packageImageMap[pkg.name.toLowerCase()] || defaultPackageImage,
        };
        setInsurancePackages([packageWithImage]);
      } else {
        console.error("No valid data received from API");
        setInsurancePackages([]);
      }
    } catch (error) {
      console.error("Error fetching insurance packages:", error);
      setInsurancePackages([]);
    }
  };

  useEffect(() => {
    getAllPackageInsurance();
    if (accountData?.insuranceSubscriptionId) {
      setIsAffiliated(true);
      setAffiliatedPackageId(accountData.insuranceSubscriptionId);
    }
  }, [accountData]);

  return (
    <div className="account-account-container">
      {notification && (
        <div
          className={`account-notification account-notification-${notification.type}`}
        >
          <p>{notification.message}</p>
          {notification.type === "success" && (
            <button
              className="account-notification-button"
              onClick={handleNavigateAddInsured}
            >
              {t("Ajouter un assuré")}
            </button>
          )}
          <button
            className="account-notification-close"
            onClick={() => setNotification(null)}
          >
            ✕
          </button>
        </div>
      )}

      <div className="account-beneficiary-account account-animate-slide-in">
        <div className="account-overlay-text">
          <i className="fas fa-piggy-bank"></i>{" "}
          {accountData?.savingPlanDescription || t("Plan indisponible")}
        </div>
      </div>

      <button
        className="account-account-button account-animate-button"
        style={{ marginBottom: "1rem" }}
        onClick={() => handleNavigateMonCompte()}
      >
        <KeyboardBackspaceIcon /> {t("carouselPrev")}
      </button>

      <div className="account-account-details account-animate-fade-in">
        <div className="account-account-header">
          <h3>
            <i className="fas fa-info-circle"></i> {t("infoAccount")}{" "}
            {accountData?.savingPlanDescription?.includes("FREESAVING")
              ? t("typeEpargne")
              : t("titleEpargne1")}
          </h3>
          <div className="account-account-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="currentColor"
              className="bi bi-person-vcard-fill"
              viewBox="0 0 16 16"
            >
              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm9 1.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5M9 8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4A.5.5 0 0 0 9 8m1 2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m-1 2C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 0 2 13h6.96q.04-.245.04-.5M7 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0" />
            </svg>
          </div>
        </div>

        <div className="account-account-info-grid">
          <div className="account-info-item-account account-animate-scale-in">
            <label>
              <i className="fas fa-user"></i> {t("titulaireAccount")}
            </label>
            <p>
              {userData?.users?.clientDetails?.fullName || t("Non disponible")}
            </p>
          </div>

          <div className="account-info-item-account account-animate-scale-in">
            <label>
              <i className="fas fa-money-bill-wave"></i> {t("amountSave")}
            </label>
            <p className="account-cible">{accountData?.balance || 0}</p>
          </div>

          <div className="account-info-item-account account-animate-scale-in">
            <label>
              <i className="fas fa-wallet"></i> {t("amountInterest")}
            </label>
            <p className="account-balance">
              {accountData?.cumulativeInterest || 0} FCFA
            </p>
          </div>

          <div>
            {accountData?.savingPlanDescription.includes(
              "FREESAVING"
            ) ? null : (
              <div className="account-info-item-account account-animate-scale-in">
                <label>
                  <i className="fas fa-bullseye"></i> {t("amountCible")}
                </label>
                <p className="account-cible">
                  {accountData?.targetAmount || 0} FCFA
                </p>
              </div>
            )}
          </div>

          <div>
            {accountData?.savingPlanDescription.includes(
              "FREESAVING"
            ) ? null : (
              <div className="account-info-item-account account-animate-scale-in">
                <label>
                  <i className="fas fa-calendar-day"></i> {t("dateObjectif")}
                </label>
                <p className="account-cible">
                  {accountData?.savingPlanDescription === "FREESAVING"
                    ? "N/A"
                    : accountData?.provisionalEndTargetDate
                    ? format(
                        parse(
                          accountData.provisionalEndTargetDate,
                          "dd-MM-yyyy",
                          new Date()
                        ),
                        "d MMMM yyyy",
                        { locale: fr }
                      )
                    : "N/A"}
                </p>
              </div>
            )}
          </div>

          <div>
            {accountData?.savingPlanDescription.includes(
              "FREESAVING"
            ) ? null : (
              <div className="account-info-item-account account-animate-scale-in">
                <label>
                  <i className="fas fa-clock"></i> {t("amountFrequency")}
                </label>
                <p className="account-frequence">
                  {accountData?.savingPlanDescription === "FREESAVING"
                    ? "N/A"
                    : `${accountData?.savingFrequencyAmount || 0} FCFA / ${
                        accountData?.savingFrequency || 0
                      } Jours`}
                </p>
              </div>
            )}
          </div>

          <div>
            {accountData?.savingPlanDescription.includes(
              "FREESAVING"
            ) ? null : (
              <div className="account-info-item-account account-animate-scale-in">
                <label>
                  <i className="fas fa-chart-line"></i> {t("progression")}
                </label>
                <div className="account-progress-container">
                  <div className="account-progress-bar">
                    <div
                      className="account-progress-fill"
                      style={{ width: `${progressPercentage}%` }}
                    ></div>
                  </div>
                  <p className="account-progress-text">{progressPercentage}%</p>
                </div>
              </div>
            )}
          </div>

          {/* <div>
            {accountData?.savingPlanDescription.includes(
              "FREE_SAVING"
            ) ? null : (
              <div className="account-info-item-account account-animate-scale-in">
                <label>
                  <i className="fas fa-calendar-day"></i>{" "}
                  {t("Date éffective l'objectif")}
                </label>
                <p className="account-cible">
                  {accountData?.savingPlanDescription === "FREESAVING"
                    ? "N/A"
                    : `${accountData?.provisionalEndTargetDate || "N/A"} `}
                </p>
              </div>
            )}
          </div> */}
        </div>

        <div className="account-insurance-packages-carousel account-animate-fade-in">
          {!isAffiliated && accountData.insuredAddStatus === "ELIGIBLE" ? (
            <div className="account-congratulations-message">
              <i className="fas fa-trophy"></i> {t("successEligile")}
            </div>
          ) : accountData.insuredAddStatus === "WAITING_PERIOD" ? (
            <div className="account-pending-message">
              <i className="fas fa-check-circle"></i> {t("pendingAssue")}
            </div>
          ) : accountData.insuranceEligibilityStatus === "DEFAULT" ? (
            <div className="account-congratulations-message">
              <i className="fas fa-info-circle"></i> {t("insuredSuccess")}
            </div>
          ) : accountData.insuranceEligibilityStatus === "INSURED" ? (
            <div className="account-ineligible-message">
              <i className="fas fa-info-circle"></i> {t("beneficieInsurance")}
            </div>
          ) : (
            <div className="account-congratulations-message">
              <i className="fas fa-info-circle"></i> {t("insufficientfound")}
            </div>
          )}
          <h4 className="account-carousel-header">
            <i className="fas fa-shield-alt"></i> {t("nosPackages")}
          </h4>
          <div className="account-carousel-container">
            {insurancePackages.map((pkg) => {
              const isEligible =
                accountData?.balance >= pkg.eligibleInsuranceAmount;
              const isAffiliatedPackage = accountData.associatedWithAAsured;
              const addInsuredStatus = accountData.insuredAddStatus;

              // const shouldDisable =
              //   (isAffiliated && !isAffiliatedPackage) || !isEligible;

              return (
                <div
                  key={pkg.id}
                  className={`account-package-item account-animate-pulse-in  ${
                    isAffiliatedPackage || addInsuredStatus === "WAITING_PERIOD"
                      ? "account-pending account-disabled"
                      : ""
                  }`}
                  onClick={() => {
                    if (
                      addInsuredStatus === "ELIGIBLE" ||
                      (addInsuredStatus !== "WAITING_PERIOD" &&
                        addInsuredStatus !== "INSURED")
                    ) {
                      handleSelectPackage(pkg);
                    }
                  }}
                  title={
                    isAffiliatedPackage || addInsuredStatus === "PENDING"
                      ? t("Vous êtes déjà affilié à ce package")
                      : isEligible
                      ? pkg.name
                      : `${t("Épargnez")} ${(
                          pkg.eligibleInsuranceAmount -
                          (accountData?.balance || 0)
                        ).toLocaleString()} FCFA ${t(
                          "de plus pour débloquer"
                        )} ${pkg.name}`
                  }
                >
                  <img
                    src={pkg.image}
                    alt={`${pkg.name} Package`}
                    className="account-package-icon"
                  />
                  {isAffiliatedPackage && (
                    <div className="account-affiliated-badge">
                      {t("assuredInsurance")}
                    </div>
                  )}
                  {isAffiliatedPackage ||
                    (addInsuredStatus === "WAITING_PERIOD" && (
                      <div className="account-pending-badge ">
                        {t("pendingInsurance")}
                      </div>
                    ))}
                  <span className="account-package-label">{pkg.name}</span>
                  {/* <span className="account-package-target">
                    {t("Cible")}: {pkg.eligibleInsuranceAmount.toLocaleString()}{" "}
                    FCFA
                  </span> */}
                </div>
              );
            })}
          </div>
        </div>

        <div className="account-account-actions">
          <button
            className="account-account-button account-animate-button"
            onClick={() => handleNavigateHistory()}
          >
            <i className="fas fa-list-alt"></i> {t("transactionButon")}
          </button>

          <button
            className="account-account-button account-animate-button"
            onClick={() => handleNavigate(accountData?.contractNumber)}
          >
            <i className="fas fa-file-alt"></i> {t("declarationButton")}
          </button>

          <button
            className="account-account-button account-animate-button"
            onClick={() => handleNavigateInsured()}
          >
            <i className="fas fa-user-shield"></i> {t("assueButton")}
          </button>
        </div>
      </div>

      {showModal && selectedPackage && (
        <div className="account-modal-overlay">
          <div className="account-modal-content account-animate-scale-in">
            <h3>
              {t("Confirmation du Package")} {selectedPackage.name}
            </h3>
            <p>
              {t("confirmPackage")}{" "}
              {selectedPackage.hospitalizationAmountToBenefit?.toLocaleString()}{" "}
              FCFA, {t("confirmPackage2")}{" "}
              {selectedPackage.funeralsAmountToBenefit?.toLocaleString()} FCFA,
            </p>
            <p>
              <strong>{t("Note")}:</strong> {t("confirmPackage3")}
            </p>
            <div className="account-modal-actions">
              <button
                className="account-account-button account-modal-button account-confirm"
                onClick={() => handleNavigateAddInsured()}
              >
                {t("confirmButton")}
              </button>
              <button
                className="account-account-button account-modal-button account-cancel"
                onClick={handleCloseModal}
              >
                {t("Back")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountPage;
